<template>
    <div class="wrapper lyrics orange">
        <div class="mycontent">

          <div class="row">
            <div class="vAligner">

              <div class="large-6 medium-12 small-12 columns content-section" data-aos="fade-right" data-aos-delay="0" data-aos-offset="0">

                <div class="lyrics__container">
                  <h2>{{  Content.title }}</h2>
                  <p>{{  Content.lyrics }}</p>
                </div>

              </div>

              <div class="large-6 medium-12 small-12 columns">
                <img :src="`${Content.img}`" alt="Christina Aguilera" data-aos="fade-left" data-aos-delay="0" data-aos-offset="0">
              </div>

            </div>
          </div>

        </div>
      </div>
</template>
    
<script>
    let lang = process.env.VUE_APP_LOCALITY;
    import Content from "../data/content";
    
    export default {
        name: 'Lyrics',
        data: function() {
            return {
              Content: Content[lang].lyrics,
            }
        }
    }
</script>

<style lang="scss">
.lyrics .mycontent {
  z-index: 101;
  position: relative;
  border-radius: 30px;
  padding: 80px 0 0;

  @media only screen and (max-width :1023px){
    padding: 40px 0 0;
  }

  .vAligner {
    justify-content: space-between;
  }
}
.lyrics .mycontent .columns:first-of-type img {
  display: block;
}
.content-section {
  border-radius: 30px;
  background: white;
  max-height: 620px;
  padding: 35px 40px !important;
  overflow: scroll;
  margin-bottom: 80px;
  position: relative;
}

.lyrics__container {
  height: 100%;
  overflow-y: scroll;
  max-height: 500px;
  margin-right: -20px;
  &::-webkit-scrollbar {
    width: 8px;
  }

  /* Track */
  &::-webkit-scrollbar-track {
    background: #EFEDEA;
    border-radius: 30px;
  }
  
  /* Handle */
  &::-webkit-scrollbar-thumb {
    background: #242E30;
    border-radius: 30px; 
  }

  /* Handle on hover */
  &::-webkit-scrollbar-thumb:hover {
    background: #555; 
  }
}
.content-section h2 {
  margin-bottom: 15px;
  text-align: left;
  color: #242E30;
  font-size: 22px;
  line-height: 130%;
  max-width: 370px;
  white-space: break-spaces;

  @media only screen and (max-width :1023px){
    font-size: 18px;
    line-height: 130%;
    text-align: center;
  }
}
.content-section p {
  padding: 0;
  text-align: center;
  font-size: 16px;
  line-height: 24px;
  color: #242E30;
  max-widtH: 370px;
  text-align: left;
  white-space: pre-line;

  @media only screen and (max-width :1023px){
    font-size: 14px;
    line-height: 150%; /* 21px */
    text-align: center;
  }

}
.content-section p span {
  height: 100%;
}

.lyrics .columns:first-of-type {
  max-widtH: 500px;

  @media only screen and (max-width :1023px){
    order: 2;
    margin: 0 auto;
  }
}

.lyrics .columns:last-of-type {
  align-self: end;
  text-align: right;

  @media only screen and (max-width :1023px){
    margin-bottom: -125px;
    text-align: center;
  }

  img {
    width: 100%;
    max-height: 693px;
    max-width: 467px;
  }
}
</style>